import { Icon, IconProps } from ".";

export const Close = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M7.49994 25.4872V28.5H10.4965V25.5021H13.4782V22.5043H16.4599V19.5064H19.5399V22.5043H22.5216V25.5021H25.5033V28.5H28.4999L28.4999 25.4872H25.5182V22.4893H22.5365V19.4914H19.5548V16.5086H22.5365V13.5107H25.5182V10.5128H28.4999V7.5H25.5033V10.4979H22.5216V13.4957H19.5399V16.4936H16.4599V13.4957H13.4782V10.4979H10.4965V7.5H7.49994V10.5128H10.4816V13.5107H13.4633V16.5086H16.445V19.4914H13.4633V22.4893H10.4816V25.4872H7.49994Z" />
    </Icon>
  );
};
